import { useQuery } from '@tanstack/react-query'

import { getBankAccountConfirmedActivities } from '@src/api'
import { DefaultApiGetBankAccountConfirmedActivitiesRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks/use-axios'

export const useFetchBankAccountConfirmedActivities = (
  params: DefaultApiGetBankAccountConfirmedActivitiesRequest
) => {
  const { axiosInstance } = useAxios()
  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getBankAccountConfirmedActivities(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_BANK_ACCOUNT_CONFIRMED_ACTIVITIES],
  })
}
